import Thread from './Thread'
import ThreadContianer from './ThreadContainer'

export default ThreadContianer(Thread)
